import React from 'react';

const StaffCRM = React.lazy(() => import('pages/StaffCRM/StaffCRMPage'));

const StaffCRMRoute = [
  {
    path: '/crm-staff',
    exact: true,
    name: 'Chăm sóc 360',
    component: StaffCRM,
    function: ['CRM_STAFF', 'CRM_TASK_VIEW'],
    any: true,
  },
  {
    path: '/crm-staff/catalogs',
    exact: true,
    name: 'Danh mục Subiz',
    component: StaffCRM,
    function: ['CRM_STAFF', 'CRM_TASK_VIEW'],
    any: true,
  },
];

export default StaffCRMRoute;
